let $ = require("jquery");
let _ = require("underscore");
let Backbone = require("backbone");
let DbRecorder = require("../recorder/DbRecorder.js");
let PrinterConverterUtil = require("./PrinterConverterUtil.js");
let PrinterUtil = require("./PrinterUtil.js");

let main = function ($, _, Backbone, DbRecorder, PrinterConverterUtil, PrinterUtil) {
    return Backbone.Model.extend({
        _print: function (bill,pos) {
            var printSetting = pos.getPrinterSetting(), result, bytes;
            var billDetail = DbRecorder.convert2JSON(bill), editorExtensionId = DbRecorder.read("chromeAppId");
            var printerSetting = DbRecorder.read("networkPrinterSetting") || [];
            if (pos.getRestaurant().get('fastFood')) {
                billDetail.fastfood = true;
            }
            billDetail.table = DbRecorder.convert2JSON(bill.table);
            if (printSetting.get("itemSlip")) {
                result = PrinterConverterUtil.toEachItemReceipts(billDetail, null);
                if (window.AndroidClient) {
                    if (printerSetting.length > 0) {
                        _.each(printerSetting, function (printer) {
                            _.each(printer.types, function (type) {
                                if (type == "EachItem") {
                                    _.each(result, function (data) {
                                        var contained = true;
                                        if (data.tags && data.tags.length > 0 && printer.tags && printer.tags.length > 0) {
                                            contained = _.any(printer.tags, function (it) {
                                                return _.any(data.tags, function (tag) {
                                                    return tag == it;
                                                });
                                            });
                                        } else {
                                            contained = true;
                                        }
                                        if (contained) {
                                            bytes = PrinterUtil.formatForAndroid(data.data, {
                                                width: printer.width,
                                                margin: 3
                                            });
                                            window.AndroidClient.print(bytes, printer.ip);
                                        }
                                    });
                                }
                            });
                        });
                    }
                }
                chrome.runtime.sendMessage(editorExtensionId, {msg: result});
                bill.set({"printed": true});
            }
        }
    });
};

let exportedValue = main($, _, Backbone, DbRecorder, PrinterConverterUtil, PrinterUtil);
module.exports = exportedValue;



// WEBPACK FOOTER //
// ./src/utils/PrinterModalUtil.js